import React, { useState, useCallback } from 'react';
import { EventPost, EventMetadata } from '@feature/event-detail/types';
import { EventHeader } from './EventHeader';
import { EventInfo } from './EventInfo';
import { EventChat } from './EventChat';
import { SplitScreen } from './SplitScreen';

interface Props {
  event: EventPost;
  metadata: EventMetadata;
}

const SCROLL_EXPAND_RATIO = 0.7;

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(var(--vh, 1vh) * 100)',
    backgroundColor: '#fff',
  },
  contentWrapper: {
    flex: 1,
    position: 'relative',
    overflow: 'hidden',
  },
};

export function EventDetailBefore({ event, metadata: initialMetadata }: Props): React.ReactElement {
  const [metadata] = useState<EventMetadata>(initialMetadata);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  const handleTopSplitRatioChange = useCallback((ratio: number) => {
    const nextExpanded = ratio >= SCROLL_EXPAND_RATIO;
    setIsDescriptionExpanded(nextExpanded);
  }, []);

  const topContentWrapperStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    overflowY: isDescriptionExpanded ? 'auto' : 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };

  const TopContent = () => {
    return (
      <div style={topContentWrapperStyle}>
        <EventInfo
          event={event}
          mode="before"
          attendeeCount={metadata.attendee_count}
          isDescriptionExpanded={isDescriptionExpanded}
        />
      </div>
    );
  };

  const BottomContent = () => {
    return <EventChat chatChannelId={event.chat_channel_id ?? undefined} eventId={event.id.toString()} />;
  };

  return (
    <div style={styles.container}>
      <EventHeader event={event} metadata={metadata} mode="before" />

      <div style={styles.contentWrapper}>
        <SplitScreen
          topContent={<TopContent />}
          bottomContent={<BottomContent />}
          onSplitRatioChange={handleTopSplitRatioChange}
        />
      </div>
    </div>
  );
}
